import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Alert, AlertTitle, Typography } from '@mui/material'

import styles from '../MicroLearningDetail.module.css'

const CompletedExperimentBanner = () => (
  <Alert severity='warning' icon={<WarningAmberIcon />} className={styles.warningBanner}>
    <AlertTitle>New experiment results are available.</AlertTitle>
    <Typography variant='body2'>
      Experiments that were previously in-pipeline have completed. Regenerate this micro-learning to incorporate the
      latest results.
    </Typography>
  </Alert>
)

export default CompletedExperimentBanner
